let orfIdSeq = 0;
function getFastId(prefix = "orf_") {
  return `${prefix}${Date.now().toString(36)}_${(++orfIdSeq).toString(36)}`;
}
import getReverseComplementSequenceString from "./getReverseComplementSequenceString";
export default function getOrfsFromSequence(options) {
  let sequence = options.sequence;
  const minimumOrfSize = options.minimumOrfSize;
  const forward = options.forward;
  const circular = options.circular;
  const useAdditionalOrfStartCodons = options.useAdditionalOrfStartCodons;
  const originalSequenceLength = sequence.length;
  if (!forward) {
    sequence = getReverseComplementSequenceString(sequence);
  }
  if (circular) {
    sequence += sequence;
  }
  const re = useAdditionalOrfStartCodons ? /(?=((?:A[TU]G|G[TU]G|C[TU]G)(?:.{3})*?(?:[TU]AG|[TU]AA|[TU]GA)))/gi : /(?=((?:A[TU]G)(?:.{3})*?(?:[TU]AG|[TU]AA|[TU]GA)))/gi;
  let m;
  const orfRanges = [];
  while ((m = re.exec(sequence)) !== null) {
    if (m.index === re.lastIndex) {
      re.lastIndex++;
    }
    const orfLength = m[1].length;
    if (orfLength >= minimumOrfSize) {
      const start = m.index;
      let end = orfLength + start - 1;
      if (end >= originalSequenceLength) {
        end -= originalSequenceLength;
      }
      if (start < originalSequenceLength) {
        orfRanges.push({
          start,
          end,
          length: m[1].length,
          internalStartCodonIndices: [],
          frame: start % 3,
          forward,
          annotationTypePlural: "orfs",
          isOrf: true,
          id: getFastId("orf_")
        });
      }
    }
  }
  const orfEnds = {};
  orfRanges.forEach((orf, index) => {
    const indexOfAlreadyExistingOrf = orfEnds[orf.end];
    if (typeof indexOfAlreadyExistingOrf !== "undefined") {
      let internalOrf = orf;
      let containingOrf = orfRanges[indexOfAlreadyExistingOrf];
      if (containingOrf.length < internalOrf.length) {
        internalOrf = orfRanges[indexOfAlreadyExistingOrf];
        containingOrf = orf;
        orfEnds[orf.end] = index;
      }
      const internalStartCodonIndex = forward ? internalOrf.start : originalSequenceLength - internalOrf.start - 1;
      containingOrf.internalStartCodonIndices = [
        ...containingOrf.internalStartCodonIndices,
        ...internalOrf.internalStartCodonIndices,
        internalStartCodonIndex
      ];
      internalOrf.remove = true;
    } else {
      orfEnds[orf.end] = index;
      if (!forward) {
        const endHolder = orf.end;
        orf.end = originalSequenceLength - orf.start - 1;
        orf.start = originalSequenceLength - endHolder - 1;
      }
    }
  });
  const nonDuplicatedOrfRanges = orfRanges.filter((orf) => {
    if (!orf.remove) {
      return true;
    }
    return false;
  });
  return nonDuplicatedOrfRanges;
}
